import React from 'react'
//import axios from 'axios'
import { useGlobalContext } from '../context'
import Player from './Player'
import Checkout from './Checkout'


function Players() {
    const { checkout, page, changePage,dropdown, share} = useGlobalContext();
    //const url = "https://www.balldontlie.io/api/v1/players" ;
    if (!checkout) {
        return (
            <React.Fragment>
            <section id="store" className="store pt-5 mt-5 pb-0" style={{minHeight:'89vh'}}>
                <div className="container m-0">
                    <div className="row pb-3 store-items" id="store-items">
                        <Player ></Player>
                    </div>
                </div>
            </section>
            <footer className='page-numbers ml-3'>
                <button onClick={changePage} className={`btn-danger ${page === '1' ? "highlight" : ""}`}>1</button>
                <button onClick={changePage} className={`btn-danger ${page === '2' ? "highlight" : ""}`}>2</button>
                <button onClick={changePage} className={`btn-danger ${page === '3' ? "highlight" : ""}`}>3</button>
                <button onClick={changePage} className={`btn-danger ${page === '4' ? "highlight" : ""}`}>4</button>
            </footer>
            </React.Fragment>
        )
    } else {
        let squad = dropdown.map(player => { return player.name} )
        return (
            <section id="store" className="store pt-5 mt-5 pb-0" style={{minHeight:'100vh', zIndex:3}}>
                <div className="container m-0">
                    <div className="margin row pb-3 store-items" id="store-items">
                        <Checkout></Checkout>
                    </div>
                    <a style={{display:'block',marginLeft:'50%'}} className='download'  onClick={share}>Download your starting five!</a>
                </div>
            </section>
        )
    }
    
}

export default Players